import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../components/modal-window';
import PhotogalleryLayout from '../../containers/photogallery-layout';
import Wrapper from '../../components/wrapper';
import Slider from '../../components/slider';
import PhotoInfo from '../../containers/photo-info';
import YoutubePlayer from '../../components/youtube-player';
import { WINDOW, DOCUMENT } from "../../constants/environment";
import { DEFAULT_THRESHOLD_NORMAL } from '../../constants/layout';
import Cta from '../cta';
import NextIconDark from '../cta/icon_next_dark.png'

import './styles.css';
// import BodyControl from "../../components/body";
import ScrollLoader from '../../components/scroll-loader';

export default class Photogallery extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    photogalleryItem: PropTypes.arrayOf(PropTypes.node),
    photogalleryLayout: PropTypes.arrayOf(PropTypes.node),
    readMoreButtonText: PropTypes.string,
    readMoreMbColumn: PropTypes.string,
    deleteMarginOnPc: PropTypes.bool,
    pcDisplayLine: PropTypes.number,
    mbDisplayLine: PropTypes.number,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    photogalleryItem: null,
    photogalleryLayout: null,
    readMoreButtonText: null,
    readMoreMbColumn: null,
    deleteMarginOnPc: null,
    pcDisplayLine: 1,
    mbDisplayLine: 1,
  };

  constructor(props) {
    super(props);
    this.itemCount = 0;
    this.itemLength = this.props.photogalleryItem.length;
    this.itemsProps = [];
    this.state = {
      page: 1
    };

    // EPIServerのプレビュー時のモーダルの位置調整
    // this.wrapperScrollTop = 0;

  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const windowWidth = window.innerWidth;

    this.setState({
      windowWidth: windowWidth,
    });
  };

  onClickMore = (event) => {
    // スクロール位置を固定
    document.activeElement.blur();
    event.preventDefault();
    this.setState(state => ({ page: state.page + 1 }));
  }

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      photogalleryItem,
      photogalleryLayout,
      readMoreButtonText,
      readMoreMbColumn,
      deleteMarginOnPc,
      pcDisplayLine,
      mbDisplayLine,
    } = this.props;
    // モーダル用データ整形
    this.itemsProps = [];
    this.itemCount = 0;
    photogalleryItem.map((item, index) => {
      this.itemsProps.push({
        pcDescription: (item.props.pcDescription) ? item.props.pcDescription: null,
        mbDescription: (item.props.mbDescription) ? item.props.mbDescription: null,
        modalWindowLayout: (item.props.modalWindowLayout) ? item.props.modalWindowLayout: null,
        pcModalImageSrc: (item.props.pcModalImageSrc) ? item.props.pcModalImageSrc: null,
        mbModalImageSrc: (item.props.mbModalImageSrc) ? item.props.mbModalImageSrc: null,
        imageSrc: (item.props.imageSrc) ? item.props.imageSrc: null,
        youtubeId: (item.props.youtubeId) ? item.props.youtubeId: null,
        autoPlay: (item.props.autoPlay) ? item.props.autoPlay: null,
        photoInfo: (item.props.photoInfo) ? item.props.photoInfo: null,
      })
    });

    const plainLargeLayout = { props: { layout: 'Large' } };
    const plainMediumLayout = { props: { layout: 'Medium' } };

    const mbColumn = readMoreMbColumn === 'Two-Column' ? 2 : 1;

    const isPc = this.state.windowWidth >= DEFAULT_THRESHOLD_NORMAL;
    const isEnabledReadMore = !!readMoreButtonText;


    let needMore = false;
    let showingPhotogalleryLayout = [];

    if (isEnabledReadMore) {
      // モバイル用Layoutの成形
      const mbFirstDisplayLayout = (new Array(photogalleryItem.length < mbDisplayLine ? photogalleryItem.length : mbDisplayLine)).fill(null).map(_ => plainLargeLayout);
      const mbPhotogalleryLayout = mbFirstDisplayLayout
        .concat((new Array(Math.floor((photogalleryItem.length - mbFirstDisplayLayout.length) / mbColumn))).fill(null)
        .map(_ => readMoreMbColumn === 'Two-Column' ? plainMediumLayout : plainLargeLayout))
        .concat((photogalleryItem.length - mbFirstDisplayLayout.length) % mbColumn ? [plainLargeLayout] : []);

      showingPhotogalleryLayout = isPc ?
        photogalleryLayout.filter((_, i) => i < this.state.page * pcDisplayLine) :
        mbPhotogalleryLayout.filter((_, i) => i < this.state.page * mbDisplayLine);

      needMore = isPc ?
        showingPhotogalleryLayout.length < photogalleryLayout.length :
        showingPhotogalleryLayout.length < mbPhotogalleryLayout.length;

    } else {
      const mbPhotogalleryLayout = (new Array(Math.floor(photogalleryItem.length))).fill(null)
        .map(_ => plainLargeLayout)

      showingPhotogalleryLayout = isPc ? photogalleryLayout : mbPhotogalleryLayout;
    }


    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}>
        <ScrollLoader>
          <div className="Photogallery">
            <div className={`Photogallery__container ${deleteMarginOnPc && 'deleteMarginOnPc'}`}>
            {showingPhotogalleryLayout.map((layout, index) => {
                const items = [];
                let length = 0;
                if (layout.props.layout === 'Large') {
                  length = 1;
                } else if (layout.props.layout === 'Medium') {
                  length = 2;
                } else if (layout.props.layout === '2-Small-Left-Medium-Right' || layout.props.layout === 'Medium-Left-2-Small-Right') {
                  length = 3;
                }
                for (let i = 0; i < length; i += 1) {
                  if (this.itemCount + i <= this.itemLength - 1) {
                    items.push(photogalleryItem[this.itemCount + i]);
                  }
                }
                this.itemCount = this.itemCount + length;
                if (items.length >= 1 && items.length === length) {
                  return (
                    <PhotogalleryLayout
                      {...layout.props}
                      key={index}
                      index={this.itemCount - length}
                      openModal={this.openModal}>
                      {items}
                    </PhotogalleryLayout>
                  )
                }
                  return null;
              })}
              {needMore &&
              <div
                className="Photogallery__container__btn__more">
                <Cta
                  ctaType="Free"
                  text={readMoreButtonText}
                  linkType="Text-With-Icon"
                  color="Dark"
                  iconSrc={NextIconDark}
                  hoverIconSrc={NextIconDark}
                  handleClick={this.onClickMore} />
              </div>
              }
            </div>
            <ModalWindow
              ref="modalWindow"
              type="Light"
              onClose={this.onCloseModal}>
              <ModalItems
                ref="modalItems"
                index={0}
                itemsProps={this.itemsProps}
                onChange={this.onChangeModal} />
            </ModalWindow>
          </div>
        </ScrollLoader>
      </Wrapper>
    );
  }

  //
  openModal = (index) => {

    // // EPIServerのプレビュー時のモーダルの位置調整
    // if (WINDOW && WINDOW.epi && WINDOW.parent) {
    //   const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
    //   if (wrapperElement) {
    //     const wrapperHeight = wrapperElement.clientHeight;
    //     this.wrapperScrollTop = wrapperElement.scrollTop;
    //     const iframe = wrapperElement.querySelector('iframe');
    //     if (iframe) {
    //       DOCUMENT.body.style.position = 'absolute';
    //       DOCUMENT.body.style.top = -this.wrapperScrollTop + 'px';
    //       const headerElement = WINDOW.document.querySelector('header') || null;
    //       if (headerElement) {
    //         headerElement.style.zIndex = 0;
    //       }
    //       iframe.style.height = wrapperHeight + 'px';
    //     }
    //   }
    // }

    this.refs.modalItems.slickGoTo(index, true);
    //
    if (this.itemsProps[index].youtubeId !== null && this.itemsProps[index].youtubeId !== '') {
      this.refs.modalWindow.open('Dark', 'Dark');
    } else {
      if (this.itemsProps[index].modalWindowLayout === 'Image-On-Top') {
        this.refs.modalWindow.open('Light', 'Dark');
      } else {
        this.refs.modalWindow.open('Light', 'Light');
      }
    }

    // BODYのスクロール無効化
    // BodyControl.openModal();
  };

  //
  onCloseModal = () => {

    // // EPIServerのプレビュー時のモーダルの位置調整
    // if (WINDOW && WINDOW.epi && WINDOW.parent) {
    //   const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
    //   if (wrapperElement) {
    //     const iframe = wrapperElement.querySelector('iframe');
    //     if (iframe) {
    //       DOCUMENT.body.style.position = 'static';
    //       DOCUMENT.body.style.top = 'auto';
    //       const headerElement = WINDOW.document.querySelector('header') || null;
    //       if (headerElement) {
    //         headerElement.style.zIndex = 3000;
    //       }
    //       iframe.style.height = DOCUMENT.body.clientHeight + 'px';
    //       wrapperElement.scrollTop = this.wrapperScrollTop;
    //     }
    //   }
    // }

    this.refs.modalItems.clearCurrentAll();

    // BODYのスクロール無効化を解除
    // BodyControl.closeModal();
  };

  //
  onChangeModal = (index) => {
    if (this.itemsProps[index].youtubeId !== null && this.itemsProps[index].youtubeId !== '') {
      this.refs.modalWindow.setType('Dark', 'Dark');
    } else {
      if (this.itemsProps[index].modalWindowLayout === 'Image-On-Top') {
        this.refs.modalWindow.setType('Light', 'Dark');
      } else {
        this.refs.modalWindow.setType('Light', 'Light');
      }
    }
  }

}

class ModalItems extends Component {
  static propTypes = {
    itemsProps: PropTypes.array,
    index: PropTypes.number,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    itemsProps: null,
    index: null,
    onChange: null,
  };

  constructor(props) {
    super(props);
    this.modalItemArr = [];
  }

  //
  clearCurrentAll() {
    let i, max;
    for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
      const item = this.refs[this.modalItemArr[i]] || null;
      if (item) {
        item.clearCurrent();
      }
    }
  }

  render() {
    const {
      itemsProps,
      index,
    } = this.props;
    //
    this.modalItemArr = [];
    //
    return (
      <Slider
        ref="slider"
        settings={{
          autoplay: false,
          speed: 3000,
          ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
          fade: true,
          infinite: true,
          initialSlide: index,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          draggable: false,
          arrows: true,
          dots: false,
          adaptiveHeight: false,
          //lazyLoad: 'progressive',
          lazyLoad: 'ondemand',
          waitForAnimate: false,
          beforeChange: (old, current) => {
            setTimeout(() => {
              this.onChange(current);
            }, 100);
            this.refs.slider.beforeChange(old, current);
          },
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: false,
                dots: true,
              },
            },
          ],
        }}
      >
        {itemsProps.map((itemProps, index) => {
          this.modalItemArr.push('modalItem' + index);
          return (
            <ModalItem
              ref={'modalItem' + index}
              key={index}
              pcDescription={(itemProps.pcDescription) ? itemProps.pcDescription: null}
              mbDescription={(itemProps.mbDescription) ? itemProps.mbDescription: null}
              modalWindowLayout={(itemProps.modalWindowLayout) ? itemProps.modalWindowLayout: null}
              pcModalImageSrc={(itemProps.pcModalImageSrc) ? itemProps.pcModalImageSrc: null}
              mbModalImageSrc={(itemProps.mbModalImageSrc) ? itemProps.mbModalImageSrc: null}
              imageSrc={(itemProps.imageSrc) ? itemProps.imageSrc: null}
              youtubeId={(itemProps.youtubeId) ? itemProps.youtubeId: null}
              autoPlay={(itemProps.autoPlay) ? itemProps.autoPlay: null}
              photoInfo={(itemProps.photoInfo) ? itemProps.photoInfo: null}
              index={index}
            />
          )
        })}
      </Slider>
    );
  }

  //
  onChange = (index) => {
    let i, max;
    for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
      const item = this.refs[this.modalItemArr[i]] || null;
      if (item) {
        if (i === index) {
          item.setCurrent();
        } else {
          item.clearCurrent();
        }
      }
    }
    //
    if (this.props.onChange !== null) this.props.onChange(index);
  };

  //
  slickGoTo = (index, dontAnimate) => {
    this.refs.slider.slickGoTo(index, dontAnimate);
    setTimeout(() => {
      this.onChange(index);
    }, 100);
  }

}

class ModalItem extends Component {
  static propTypes = {
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    modalWindowLayout: PropTypes.string,
    imageSrc: PropTypes.string,
    pcModalImageSrc: PropTypes.string,
    mbModalImageSrc: PropTypes.string,
    youtubeId: PropTypes.string,
    autoPlay: PropTypes.bool,
    photoInfo: PropTypes.array,
    index: PropTypes.number,
  };
  static defaultProps = {
    pcDescription: null,
    mbDescription: null,
    imageSrc: null,
    modalWindowLayout: null,
    pcModalImageSrc: null,
    mbModalImageSrc: null,
    youtubeId: null,
    autoPlay: null,
    photoInfo: null,
    index: null,
  };

  constructor(props) {
    super(props);
    const type = (props.youtubeId !== null && props.youtubeId !== '') ? ' dark': ' light';
    this.state = {
      type: type,
      current: false,
      videoWidth: 1040,
      videoHeight: 585,
    };
    // this.intervalId = null;
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
    //   if (this.intervalId) clearInterval();
    //   this.intervalId = setInterval(()=> {
    //     this.handleResize();
    //   }, 500);
    // }

  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);

    // if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
    //   if (this.intervalId) clearInterval();
    // }

  }

  //
  setCurrent() {
    if (this.state.current === true) return;
    //
    this.setState({
      current: true,
    });

    if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
      window.scrollTo(0, 0);
    }

  };

  //
  clearCurrent() {
    if (this.state.current === false) return;
    //
    this.setState({
      current: false,
    });
  }

  render() {
    const {
      pcDescription,
      mbDescription,
      modalWindowLayout,
      imageSrc,
      pcModalImageSrc,
      mbModalImageSrc,
      youtubeId,
      autoPlay,
      photoInfo,
    } = this.props;
    //
    const getPcDescription = () => {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return '';
      }
    };
    //
    const getMbDescription = () => {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };
    //
    const getPcImageSrc = () => {
      if (pcModalImageSrc && pcModalImageSrc !== '') {
        return pcModalImageSrc;
      } else if (imageSrc && imageSrc !== '') {
        return imageSrc;
      } else {
        return '';
      }
    };
    //
    const getMbImageSrc = () => {
      if (mbModalImageSrc && mbModalImageSrc !== '') {
        return mbModalImageSrc;
      } else {
        return getPcImageSrc();
      }
    };
    //
    let layoutClass = null;
    let description = getPcDescription();
    if (description && description !== '') {
      if (modalWindowLayout === 'Image-On-Top') {
        layoutClass = ' imageOnTop';
      } else if (modalWindowLayout === 'Image-On-Left') {
        layoutClass = ' imageOnLeft';
      }
    } else {
      layoutClass = ' fullSize';
    }
    //
    const pcImageSrc = getPcImageSrc();
    const mbImageSrc = getMbImageSrc();
    //
    return (
      <div
        className={'Photogallery__modal' + this.state.type + ((layoutClass) ? layoutClass: '') + ((this.state.current === true) ? ' current': '')}
        style={{height: this.state.windowHeight}}
      >
        <div className="Photogallery__modal-container"
             style={{height: this.state.windowHeight}}
        >
          {(() => {
            if (youtubeId && youtubeId !== '') {
              if (this.state.current === true) {
                return (
                  <div className="Photogallery__modal-container-left-pc" ref="videoWrapper">
                    <YoutubePlayer
                      height={this.state.videoHeight}
                      width={this.state.videoWidth}
                      autoplay={autoPlay ? 1 : 0}
                      controls={0}
                      youtubeId={youtubeId}
                      onReady={(e) => {
                        //console.log('onReady');
                      }}
                      onStateChange={(e) => {
                        //console.log('onStateChange');
                      }}
                    />
                    {/*<iframe style={{width: this.state.videoWidth, height: this.state.videoHeight}}*/}
                    {/*width="100%"*/}
                    {/*height="100%"*/}
                    {/*src={'https://www.youtube.com/embed/' + youtubeId + '?autoplay=0&rel=0&showinfo=0&controls=1&enablejsapi=1'}*/}
                    {/*/>*/}
                    {(photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length) ?
                      <PhotoInfo {...photoInfo[0].props}/>
                      : null}
                  </div>
                )
              } else {
                return (
                  <div className="Photogallery__modal-container-left-pc"/>
                )
              }
            } else if (pcImageSrc && pcImageSrc !== '') {
              return (
                <div className="Photogallery__modal-container-left-pc"
                     style={{backgroundImage: 'url(' + pcImageSrc + ')'}}
                >
                  {(photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length) ?
                    <PhotoInfo {...photoInfo[0].props}/>
                    : null}
                </div>
              )
            } else {
              return (
                <div className="Photogallery__modal-container-left-pc"/>
              );
            }
          })()}
          <div className="Photogallery__modal-container-left-mb">
            {(() => {
              if (youtubeId && youtubeId !== '') {
                if (this.state.current === true) {
                  return (
                    <div className="Photogallery__modal-movie-wrapper">
                      <YoutubePlayer
                        height={'100%'}
                        width={'100%'}
                        autoplay={autoPlay ? 1 : 0}
                        controls={0}
                        youtubeId={youtubeId}
                        onReady={(e) => {
                          //console.log('onReady');
                        }}
                        onStateChange={(e) => {
                          //console.log('onStateChange');
                        }}
                      />
                      {/*<iframe*/}
                      {/*width="100%"*/}
                      {/*height="100%"*/}
                      {/*src={'https://www.youtube.com/embed/' + youtubeId + '?autoplay=0&rel=0&showinfo=0&controls=1&enablejsapi=1'}*/}
                      {/*/>*/}
                    </div>
                  )
                } else {
                  return null
                }
              } else if (mbImageSrc && mbImageSrc !== '') {
                return (
                  <div>
                    <img className="Photogallery__modal-image"
                         src={mbImageSrc}
                    />
                    <div className="Photogallery__modal-image-cover"/>
                  </div>
                )
              } else {
                return null;
              }
            })()}
            {(photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length) ?
              <PhotoInfo {...photoInfo[0].props}/>
              : null}
          </div>
          <div className="Photogallery__modal-container-right">
            <div className="Photogallery__modal-inner">
              <div className="Photogallery__modal-description-pc Wysiwyg"
                //style={{height: this.state.windowHeight}}
                   dangerouslySetInnerHTML={{__html: getPcDescription()}}
              />
              <div className="Photogallery__modal-description-mb Wysiwyg"
                   dangerouslySetInnerHTML={{__html: getMbDescription()}}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  //
  handleResize = () => {
    const windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;

    //
    let videoWidth = 0;
    let videoHeight = 0;
    if (this.props.modalWindowLayout === 'Image-On-Top') {
      videoWidth = 1040;
      videoHeight = 585;
    } else if (this.props.modalWindowLayout === 'Image-On-Left') {
      videoWidth = windowWidth * 0.67;
      videoHeight = (windowWidth * 0.67 / 16) * 9;
    }

    // EPIServerのプレビュー時のモーダルの位置調整
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        windowHeight = wrapperElement.clientHeight;
      }
    }

    //
    this.setState({
      videoWidth: videoWidth,
      videoHeight: videoHeight,
      windowWidth: windowWidth,
      windowHeight: windowHeight,
    });
  };

}



// WEBPACK FOOTER //
// ./src/containers/photogallery/index.jsx